module.exports = __webpack_public_path__ + "img/FI.0cca757b.svg";